export class Language {
  label = '';
  code = '';

  get value(): string {
    return this.code;
  }

  get detail(): string {
    return `(${this.code.toUpperCase()})`;
  }

  constructor(label: string, code: string) {
    this.label = label;
    this.code = code;
  }
}
